// src/theme.js
import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    primary: {
      main: '#336699', // Custom primary color
    },
    secondary: {
      main: '#336699', // Custom secondary color for hover
    },
  },
});

export default theme;
